module.exports = function () {
  return "<div id='game_board_size_toggle'><i class=\"fa-solid fa-maximize\"></i></div>";
};